import { useId } from "react";
import { UncontrolledTooltip } from "reactstrap";

/** Marks an amount as a live-computed estimate (DRAFT + PERCENTAGE, base has since changed) rather than a locked-in figure. */
export default function LivePreviewBadge({ className = "" }: { className?: string }) {
  const id = `live-preview-${useId().replace(/:/g, "")}`;

  return (
    <>
      <span
        id={id}
        className={`badge bg-warning-subtle text-warning ms-1 ${className}`}
      >
        <i className="ri-refresh-line align-middle me-1" />
        Live estimate
      </span>
      <UncontrolledTooltip target={id}>
        This is a live estimate, not a locked-in figure — it will be finalized when the advance is received.
      </UncontrolledTooltip>
    </>
  );
}
